module.exports = __webpack_public_path__ + "static/money-lion-90603a9b378de033937e0ca43d98672a.svg";